export const USPVariantAModuleName = 'Usp Variant A';
